/* istanbul ignore next */

/** This is a syntactic sugar for `columns` prop. So HOC will not work on this. */
// eslint-disable-next-line no-unused-vars
function Column(_) {
  return null;
}

export default Column;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/table/Column.js
// module id = 1108
// module chunks = 0